import { createFileRoute } from '@tanstack/react-router';
import { isPermissionFull } from '@/features/login/util/permission';
import { validateRoute } from '@/router/util';

export const Route = createFileRoute('/a/estoque')({
    beforeLoad: () =>
        validateRoute({
            fintech: false,
            validatePermission: ({ upp_estoque_estoque }) => isPermissionFull(upp_estoque_estoque),
        }),
});
